import * as angular from 'angular';

import { DigitalCorrespondanceTable } from '@models/index';
import { IRequestService } from '../request.service';

export interface IDigitalCorrespondanceTableService {
    getAll(force?: boolean): angular.IPromise<DigitalCorrespondanceTable[]>;
    getOne(guid: string, force?: boolean): angular.IPromise<DigitalCorrespondanceTable>;
    addOne(value: DigitalCorrespondanceTable): angular.IPromise<DigitalCorrespondanceTable>;
    updateOne(value: DigitalCorrespondanceTable): angular.IPromise<DigitalCorrespondanceTable>;
    deleteOne(guid: string): angular.IPromise<void>;
}

export class DigitalCorrespondanceTableService implements IDigitalCorrespondanceTableService {
    static serviceId = 'digitalCorrespondanceTableService';

    private _controllerUrl = 'digitalCorrespondanceTable';

    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    getAll(force?: boolean): angular.IPromise<DigitalCorrespondanceTable[]> {
        if (force) {
            this._requestService.cleanCacheAtV1(this._controllerUrl);
        }
        return this._requestService.getAtV1(this._controllerUrl);
    }

    getOne(guid: string, force?: boolean): angular.IPromise<DigitalCorrespondanceTable> {
        const url = `${this._controllerUrl}/${guid}`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url);
    }

    addOne(value: DigitalCorrespondanceTable): angular.IPromise<DigitalCorrespondanceTable> {
        const url = `${this._controllerUrl}/add`;
        return this._requestService.postAtV1<DigitalCorrespondanceTable>(url, value)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    updateOne(value: DigitalCorrespondanceTable): angular.IPromise<DigitalCorrespondanceTable> {
        const url = `${this._controllerUrl}/update`;
        return this._requestService.postAtV1<DigitalCorrespondanceTable>(url, value)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }
    
    deleteOne(guid: string): angular.IPromise<void> {
        const url = `${this._controllerUrl}/delete/${guid}`;
        return this._requestService.postAtV1<void>(url)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
            });
    }
}